import React, {useState, useEffect} from 'react' 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { Select, MenuItem, InputLabel, FormControl, Button } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import MomentUtils from "@date-io/moment";
import moment from "moment";
import PDVS from './components/PDVS';
import Paginacao from '../../components/Paginacao';
import {  getAcoesPorPeriodo, getRegionalDesempenho, getFilialDesempenho, getDesempenhoPesquisa } from '../../services/api-auto'

import styles from './styles.module.scss'

const Desempenho = () => {

    const [acao, setAcao] = useState('')
    const [tipo, setTipo] = useState('0')
    const [mes, setMes] = useState(moment())
    const [acaoList, setAcaoList] = useState([])
    const [page, setPage] = useState(1)
    const [maxPage, setMaxPage] = useState(1)
    const [regionalList, setRegionalList] = useState(["Todos"]);
    const [regional, setRegional] = useState('Todos');
    const [filialList, setFilialList] = useState(["Todos"]);
    const [filial, setFilial] = useState('Todos');
    const [pdvList, setpdvList] = useState([])

    useEffect(() => {
        getAcaoList()
    },[mes])

    const getAcaoList = async (pagina) => {
        const mesInfo = mes.month() + 1;
        const anoInfo = mes.year();
        const info = await getAcoesPorPeriodo(mesInfo, anoInfo)
        setAcaoList(info) 
    }

    useEffect(() => {
        carregarRegional()
    },[acao])

    const carregarRegional = async () =>{
        const info = await getRegionalDesempenho(acao.idAcao)
        setRegionalList(["Todos", ...info]);
    }

    useEffect(() => {
        carregarFilial()
    },[regional])

    const carregarFilial = async () =>{
        const info = await getFilialDesempenho(acao.idAcao, regional)
        setFilialList(["Todos", ...info]);
    }

    useEffect( () => {
        getAcaoList();
    },[])

    const pesquisar = async (newpage = 1) => {
        let searchInfo = {
            pagina: newpage,
            idAcao: acao.idAcao,
            periodo: mes.format("YYYY-MM-01"),
            tipoParceiro: tipo === "0" ? null : parseInt(tipo)
        }
        if(regional !== "Todos") { searchInfo.regional = regional}
        if(filial !== "Todos") { searchInfo.filial = regional}
        
        setPage(newpage);
        const info = await getDesempenhoPesquisa(searchInfo)
        setpdvList(info.data)
        setMaxPage(info.maxPage)
    }


    return(
        <div className={`${styles.wrapper}`}>
            <div className={styles.title}>
                Desempenho no programa
            </div>
            <div className={`${styles.actions}`}>
                <div className={`${styles.card}`}>
                    <div className={`${styles.cardTitle}`}>
                        Faça suas seleções
                    </div>
                    <FormControl className={styles.data}>
                        <MuiPickersUtilsProvider locale="pt-br" libInstance={moment} utils={MomentUtils}>
                            <KeyboardDatePicker
                                views={['year', 'month']}
                                autoOk
                                variant="inline"
                                inputVariant="outlined"
                                label="Até"
                                format="MMMM/yyyy"
                                value={mes}
                                InputAdornmentProps={{ position: "start" }}
                                onChange={novaData => { setMes(novaData) }}
                                className="customFilledInput"
                                error={false}
                                invalidDateMessage="Data em formato inválido."
                                maxDateMessage="Data não deve ser maior que a data máxima."
                                minDateMessage="Data não deve ser menor que a data mínima."
                            />
                        </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl>
                        <InputLabel id="select-tipo-label" className={styles.label}>
                            Ação
                        </InputLabel>
                        <Select
                            labelId='select-tipo-label'
                            label="Ação"
                            onChange={(e)=>{setAcao(e.target.value)}}
                            value={acao}
                            variant='filled'
                            className="customFilledInput"
                        >
                            {
                                acaoList.map((item) => {
                                    return(
                                        <MenuItem value={item} key={item.idAcao}>{item.nome}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel id="select-tipo-label" className={styles.label}>
                            Regional
                        </InputLabel>
                        <Select
                            labelId='select-tipo-label'
                            label="Ação"
                            onChange={(e)=>{setRegional(e.target.value)}}
                            value={regional}
                            variant='filled'
                            className="customFilledInput"
                        >
                            {
                                regionalList.map((item) => {
                                    return(
                                        <MenuItem value={item} key={item}>{item}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel id="select-tipo-label" className={styles.label}>
                            Filial
                        </InputLabel>
                        <Select
                            labelId='select-tipo-label'
                            label="Ação"
                            onChange={(e)=>{setFilial(e.target.value)}}
                            value={filial}
                            variant='filled'
                            className="customFilledInput"
                        >
                            {
                                filialList.map((item) => {
                                    return(
                                        <MenuItem value={item} key={item}>{item}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel id="select-tipo-label" className={styles.label}>
                            Tipo
                        </InputLabel>
                        <Select
                            labelId='select-tipo-label'
                            label="Ação"
                            onChange={(e)=>{setTipo(e.target.value)}}
                            value={tipo}
                            variant='filled'
                            className="customFilledInput"
                        >
                            <MenuItem value={0}>Todos</MenuItem>
                            <MenuItem value={1}>Concessionária</MenuItem>
                            <MenuItem value={2}>Loja</MenuItem>
                            <MenuItem value={3}>F&I</MenuItem>
                            
                        </Select>
                    </FormControl>
                    <FormControl>
                        <Button className={`${styles.processar} bold`} onClick={() => {pesquisar(1)}} type="button">
                            <FontAwesomeIcon icon={faSearch} className={styles.icon}/>
                            PESQUISAR
                        </Button>
                    </FormControl>
                </div>
            </div>
            <div className={`${styles.logs}`}>
                <div className={`${styles.cardTitle}`}>
                    PDVs participantes
                </div>
                <div>
                    {
                        pdvList.map( pdv =>  (<PDVS pdv={pdv}/>))
                    }
                </div>
            </div>
            <div className={styles.paginacaoWrapper}>
                <Paginacao maxPage={maxPage} page={page} setPage={pesquisar}/>
            </div>
        </div>
    )
}

export default Desempenho